module.exports = __webpack_public_path__ + "static/media/pousada_7.9323b61c.jpg";